import { HypotheticalPerformanceTabLegacy } from "features/financial-reporting/HypotheticalPerformanceTabLegacy";
import { HypotheticalPerformanceTabTable } from "features/financial-reporting/HypotheticalPerformanceTabTable";
import React from "react";
import { useFeatureFlagActive } from "shared/hooks/useFeatureFlag";

export const HypotheticalPerformanceTab: React.FC = () => {
  const isPerformanceTableActive = useFeatureFlagActive("performance_metrics");
  return isPerformanceTableActive ? (
    <HypotheticalPerformanceTabTable />
  ) : (
    <HypotheticalPerformanceTabLegacy />
  );
};
